<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <!-- <b-card> -->
            <h5 class="mb-0">
                <i class="fa fa-fw fa-cube mr-2" />Daftar Items
            </h5>
            <hr />
            <b-row>
                <b-col xs="12" sm="8" md="6" lg="5" xl="4">
                    <b-form-group label="Nama Item">
                        <b-form-input
                            v-model="filter.name"
                            maxlength="50"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
                id="local-table"
                :current-page="currentPage"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty> Tidak ada data items. </template>
                <template v-slot:cell(name)="row">
                    <small>{{ row.item.kind }} - {{ row.item.brand }}</small>
                    <p>{{ row.item.name }}</p>
                </template>
                <template v-slot:cell(stock)="row">
                    <span>{{ row.item.stock }} Unit</span>
                </template>
                <template v-slot:cell(retail_price)="row">
                    <span
                        >Rp {{ formattedCurrency(row.item.retail_price) }}</span
                    >
                </template>
                <template v-slot:cell(wholesale_price)="row">
                    <span
                        >Rp
                        {{ formattedCurrency(row.item.wholesale_price) }}</span
                    >
                </template>
                <template v-slot:cell(is_batangan)="row">
                    <span v-if="row.item.is_batangan == 0">Tidak</span>
                    <span v-else>Ya</span>
                </template>
                <template v-slot:cell(is_hidden)="row">
                    <b-badge variant="success" v-if="row.item.is_hidden == 0"
                        >Aktif</b-badge
                    >
                    <b-badge variant="danger" v-else>Nonaktif</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="d-flex">
                        <b-button
                            size="sm"
                            variant="secondary"
                            v-b-tooltip.hover.top
                            title="Detail"
                            @click="getDetail(row.item.id)"
                        >
                            <i class="fa fa-info-circle" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            :variant="
                                row.item.is_hidden == 0 ? 'danger' : 'success'
                            "
                            v-b-tooltip.hover.top
                            :title="
                                row.item.is_hidden == 0
                                    ? 'Nonaktifkan'
                                    : 'Aktifkan'
                            "
                            :disabled="
                                (row.item.role_id == 1 &&
                                    row.item.is_hidden == 1) ||
                                isBusy ||
                                isSubmitting
                            "
                            @click="confirmToggle(row.item)"
                        >
                            <i class="fa fa-fw fa-power-off" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="pageLength"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
        <b-modal
            id="m-detail"
            size="xl"
            title="Detail Data Items"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-container>
                <div class="info-container mb-3">
                    <div>
                        <h5>Data Item</h5>
                        <b-row class="mt-4">
                            <b-col cols="12">
                                <div class="img-container">
                                    <b-img-lazy
                                        class="img-item"
                                        :src="detail.itemDetail.image"
                                        alt="Gambar barang"
                                    />
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div>
                        <b-row class="mt-5">
                            <b-col cols="5">ID</b-col>

                            <b-col cols="6">
                                <p>{{ detail.itemDetail.id }}</p></b-col
                            >
                            <b-col
                                cols="5"
                                :class="{
                                    'mb-3':
                                        detail.itemDetail.inventory_id === null,
                                }"
                                >ID Barang</b-col
                            >

                            <b-col cols="6">
                                <p>
                                    {{ detail.itemDetail.inventory_id }}
                                </p></b-col
                            >
                            <b-col cols="5">Nama Barang</b-col>

                            <b-col cols="6">
                                <p>{{ detail.itemDetail.name }}</p></b-col
                            >
                            <b-col cols="5">Brand</b-col>

                            <b-col cols="6">
                                <p>{{ detail.itemDetail.brand }}</p></b-col
                            >
                            <b-col cols="5">Jenis</b-col>

                            <b-col cols="6">
                                <p>{{ detail.itemDetail.kind }}</p></b-col
                            >
                            <b-col cols="5">Spesifikasi</b-col>

                            <b-col cols="6">
                                <p>{{ detail.itemDetail.spec }}</p></b-col
                            >
                            <b-col cols="5">Grade</b-col>

                            <b-col cols="6">
                                <p>{{ detail.itemDetail.grade }}</p></b-col
                            >
                            <b-col cols="5">Batangan</b-col>

                            <b-col cols="6">
                                <p v-if="detail.itemDetail.is_batangan">Ya</p>
                                <p v-else>Tidak</p>
                            </b-col>
                            <b-col cols="5">Harga Grosir</b-col>

                            <b-col cols="6">
                                <p>
                                    {{
                                        "Rp " +
                                        formattedCurrency(
                                            detail.itemDetail.wholesale_price
                                        )
                                    }}
                                </p></b-col
                            >
                            <b-col cols="5">Harga Eceran</b-col>

                            <b-col cols="6">
                                <p>
                                    {{
                                        "Rp " +
                                        formattedCurrency(
                                            detail.itemDetail.retail_price
                                        )
                                    }}
                                </p></b-col
                            >
                            <b-col cols="5">Stok</b-col>

                            <b-col cols="6">
                                <p>{{ detail.itemDetail.stock }} Unit</p></b-col
                            >
                        </b-row>
                    </div>
                </div>
                <h5>Daftar Item</h5>
                <b-table
                    bordered
                    hover
                    show-empty
                    :busy="isBusy"
                    :items="detail.inventoryList"
                    :fields="detailHeader"
                    responsive
                    class="mb-3 mt-3"
                    id="detail-table"
                    :current-page="currentPageDetail"
                    :per-page="perPageDetail"
                >
                    <template v-slot:empty>
                        Tidak ada data item order.
                    </template>
                    <template v-slot:cell(type)="row">
                        <span style="width: 400px">{{ row.item.type }}</span>
                    </template>
                    <template v-slot:cell(is_handphone)="row">
                        <span v-if="row.item.is_handphone">Ya</span>
                        <span v-else>Tidak</span>
                    </template>
                    <template v-slot:cell(is_batangan)="row">
                        <span v-if="row.item.is_batangan">Ya</span>
                        <span v-else>Tidak</span>
                    </template>
                    <template v-slot:cell(has_been_sold)="row">
                        <span v-if="row.item.has_been_sold">Ya</span>
                        <span v-else>Tidak</span>
                    </template>

                    <template v-slot:cell(retail_price)="row">
                        <span>{{
                            "Rp " +
                            $helper.formatThousand(row.item.retail_price)
                        }}</span>
                    </template>
                    <template v-slot:cell(wholesale_price)="row">
                        <span>{{
                            "Rp " +
                            $helper.formatThousand(row.item.wholesale_price)
                        }}</span>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="d-flex">
                            <b-button
                                size="sm"
                                varian
                                t="info"
                                v-b-tooltip.hover.top
                                title="Gambar"
                                @click="showImage(row.item.photo)"
                            >
                                <i class="fa fa-file-image-o" />
                            </b-button>
                            <b-button
                                size="sm"
                                class="ml-2"
                                variant="warning"
                                v-b-tooltip.hover.top
                                title="Kerusakan"
                                @click="showAdjustments(row.item.adjustments)"
                            >
                                <i class="fa fa-chain-broken" />
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPageDetail"
                    :total-rows="detail.inventoryList.length"
                    :per-page="perPageDetail"
                    aria-controls="detail-table"
                    align="right"
                    class="mb-0"
                ></b-pagination>
            </b-container>

            <div class="mt-4 text-right">
                <b-button variant="primary" @click="close()">
                    Kembali
                </b-button>
            </div>
        </b-modal>
        <ListItemImgCarousel
            :photo="photo"
            ref="modalImageSlider"
            :isLoading="isLoading"
        />
        <ListItemAdjModal
            :adjustments="adjustments"
            ref="modalAdjustments"
            :isLoading="isLoading"
        />
    </div>
</template>

<script>
// import moment from "moment";

import ListItemImgCarousel from "./ListItemImgCarousel.vue";
import ListItemAdjModal from "./ListItemAdjModal.vue";

export default {
    data() {
        return {
            initStatus: 0,
            isFilter: false,
            isBusy: true,
            isSubmitting: false,
            filter: {
                name: "",
            },
            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],
            fields: [
                { key: "name", label: "Nama Item", sortable: true },
                { key: "grade", label: "Grade", sortable: true },
                { key: "spec", label: "Spesifikasi", sortable: true },
                { key: "stock", label: "Stok", sortable: true },
                { key: "retail_price", label: "Harga Eceran", sortable: true },
                {
                    key: "wholesale_price",
                    label: "Harga Grosir",
                    sortable: true,
                },
                { key: "is_batangan", label: "Batangan", sortable: true },
                { key: "is_hidden", label: "Status", sortable: true },
                { key: "action", label: "Aksi", sortable: false },
            ],
            detailHeader: [
                { key: "id", label: "ID", sortable: true },
                {
                    key: "inventory_id",
                    label: "ID Barang",
                    sortable: true,
                },
                { key: "type", label: "Nama Barang", sortable: true },
                { key: "year", label: "Tahun", sortable: true },
                {
                    key: "is_handphone",
                    label: "Handphone",
                    sortable: true,
                },
                { key: "is_batangan", label: "Batangan", sortable: true },
                {
                    key: "no_faktur_pgi",
                    label: "No. Faktur",
                    sortable: true,
                },
                { key: "imei_sn", label: "No. IMEI", sortable: true },
                { key: "grade", label: "Grade", sortable: true },
                { key: "has_been_sold", label: "Terjual", sortable: true },
                { key: "kind", label: "Kind", sortable: true },
                {
                    key: "wholesale_price",
                    label: "Harga Grosir",
                    sortable: true,
                },
                {
                    key: "retail_price",
                    label: "Harga Eceran",
                    sortable: true,
                },
                { key: "color", label: "Warna", sortable: true },
                { key: "action", label: "Aksi", sortable: false },
            ],
            detail: {
                itemDetail: {},
                inventoryList: [],
            },
            items: [],
            filteredItems: [],
            totalPrice: 0,
            totalAll: 0,
            currentPage: 1,
            pageLength: 0,
            perPage: 10,
            currentPageDetail: 1,
            pageLengthDetail: 0,
            perPageDetail: 3,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            photo: [],
            adjustments: [],
            isLoading: true,
        };
    },
    methods: {
        showImage(photo) {
            try {
                this.isLoading = true;
                this.$refs.modalImageSlider.$emit("hidden");
                this.photo = photo;
                this.$refs.modalImageSlider.show();
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isLoading = false;
            }
        },
        showAdjustments(adjustments) {
            try {
                this.isLoading = true;
                this.$refs.modalAdjustments.$emit("hidden");
                this.adjustments = adjustments;
                this.$refs.modalAdjustments.show();
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isLoading = false;
            }
        },
        formattedCurrency(val) {
            return val
                ? val.toLocaleString("de-DE", { minimumFractionDigits: 0 })
                : "0,00";
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        close() {
            this.$bvModal.hide("m-detail");
        },
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();
            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },
        getDetail(id) {
            this.isBusy = true;
            return this.$axios
                .get(`admin/getDetailItem?id=${id}`)
                .then((res) => {
                    const data = res.data;
                    this.detail = {
                        itemDetail: {
                            ...data.itemDetail,
                            image:
                                this.$BASE_FILE_PATH_PROD +
                                data.itemDetail.image,
                        },
                        inventoryList: data.inventoryList.map((item) => {
                            return {
                                ...item,
                                photo: item.photo.map(
                                    (i) => this.$BASE_FILE_PATH_PROD + i
                                ),
                            };
                        }),
                    };
                    this.$bvModal.show("m-detail");
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        confirmToggle(item) {
            let action = item.is_hidden == 1 ? "aktif" : "nonaktif";
            let isConfirmed = confirm(
                "Apakah anda yakin ingin meng" +
                    action +
                    'kan Item "' +
                    item.name +
                    '"?'
            );
            if (!isConfirmed) return;
            this.isSubmitting = true;
            let payload = {
                id: item.id,
                isHidden: item.is_hidden == 1 ? "false" : "true",
            };
            this.$axios
                .post("admin/hiddenItem", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Item berhasil di" + action + "kan!"
                    );
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },
        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];
            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }
            // URL builder
            // let param = this.$helper.getBasePagedQuery(
            //     this.currentPage,
            //     this.perPage
            // );
            const payload = {
                page: this.currentPage,
                perPage: this.perPage,
                filterName: this.filter.name || null,
                filterGrade: null,
                filterSpec: null,
                filterKind: null,
                filterBrand: null,
                filterDivision: null,
                filterType: null,
                filterIsBatangan: null,
                filterMinPrice: null,
                filterMaxPrice: null,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
            };
            return this.$axios
                .post(`admin/getAllItem`, payload)
                .then((res) => {
                    const data = res.data.data;
                    this.pageLength = data.total;
                    this.items = data.items;
                    this.filteredItems = data.items;
                })
                .catch((error) => {
                    // this.pageLength = 1;
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },
        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },
        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },
        onFilterChanged(items) {
            this.isFilter = true;
            this.filteredItems = items;
        },
    },
    created() {
        this.init();
    },
    components: { ListItemImgCarousel, ListItemAdjModal },
};
</script>

<style scoped>
.info-container {
    display: grid;
    grid-template-columns: 1fr 1fr 0.2fr;
}

@media (max-width: 990px) {
    .info-container {
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
    }
}

@media (max-width: 600px) {
    .info-container {
        grid-template-columns: 1fr;
    }
}

.img-container {
    height: 380px;
    width: 380px;
    background: #eee;
}

.img-item {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
}
</style>
